// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__JQsio","content":"GlobalSearch_content__2bwlK"};